import { createContext } from "react";

interface ScrollSpyContextProps {
	register: (id: string) => void;
	unRegister: (id: string) => void;
	setInView: (id: string, inView: boolean) => void;
	activeId?: string;
}

export const ScrollSpyContext = createContext<ScrollSpyContextProps>({
	register: () => ({}),
	unRegister: () => ({}),
	setInView: () => ({}),
	activeId: undefined,
});
